(function () {
  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('prepaidBillingCtrl', ['$scope', '$http', '$state', '$rootScope', 'uteEndpoint', 'httpService', 'prepaidPlanInfoService', 'prepaidAirtimeBalanceService', 'prepaidUserInfoService', 'prepaidRegisteredCCInfoService', 'prepaidAutoRefillInfoService', 'transactionHistoryService', 'uteLocale', function ($scope, $http, $state, $rootScope, uteEndpoint, httpService, prepaidPlanInfoService, prepaidAirtimeBalanceService, prepaidUserInfoService, prepaidRegisteredCCInfoService, prepaidAutoRefillInfoService, transactionHistoryService, uteLocale) {

      $scope.init = function () {

        $scope.ctn = prepaidUserInfoService.getCTN();
        $scope.ban = prepaidUserInfoService.getBAN();
        $scope.language = uteLocale.language;
        $scope.addOnPrice = 0;

        var promise = httpService.send(
          'v1/wireless/prepaid/dashboard/plan', // TODO : Need to change
          {
            accountNumber: $scope.ban,
            ctn: $scope.ctn,
            language: $scope.language
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.planAndAddOnInfoError = true;
            } else {
              //alert('Got PlanAndAddOnInfo Successfully');
              $scope.planAndAddOnInfo = result.data;
              console.log('$scope.planAndAddOnInfo :: ' + $scope.planAndAddOnInfo);
              prepaidAirtimeBalanceService.setAirTimeBalance($scope.planAndAddOnInfo.airtimeBalance);
              prepaidAirtimeBalanceService.setExpiryDate($scope.planAndAddOnInfo.expiryDate);
              prepaidPlanInfoService.setAirTimePlanFee($scope.planAndAddOnInfo.pricePlan);
              $scope.pricePlanInfo = null;
              if (result.data.planDetailsInfo != null) {
                if ($scope.language === 'en' || $scope.language === 'EN') {
                  $scope.pricePlanInfo = result.data.planDetailsInfo.en;
                } else {
                  $scope.pricePlanInfo = result.data.planDetailsInfo.fr;
                }
                if (result.data.planDetailsInfo.productId != null && result.data.planDetailsInfo.productId != '') {
                  prepaidPlanInfoService.setAirTimePlanSoc(result.data.planDetailsInfo.productId);
                } else {
                  prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                }
                if ($scope.pricePlanInfo != null && $scope.pricePlanInfo.planComparison != null && $scope.pricePlanInfo.planComparison.planTitle != null && $scope.pricePlanInfo.planComparison.planTitle != '') {
                  prepaidPlanInfoService.setAirTimePlanTitle($scope.pricePlanInfo.planComparison.planTitle);
                } else {
                  if ($scope.language === 'en' || $scope.language === 'EN') {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                  } else {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                  }
                }
              } else {
                if ($scope.language === 'en' || $scope.language === 'EN') {
                  prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                } else {
                  prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                }
                prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
              }
              $scope.planPrice = prepaidPlanInfoService.getAirTimePlanFee();
              $scope.planDesc = prepaidPlanInfoService.getAirTimePlanTitle();
              /*Changes are cherry picked as part previous release*/
              //$scope.planAndAddOnInfo.expiryDate = new Date($scope.planAndAddOnInfo.expiryDate);
              prepaidPlanInfoService.setAirTimePlanFeatures($scope.pricePlanInfo);
              $scope.addOnDetails();
              /*angular.forEach($scope.planAndAddOnInfo.addOnDetails, function(addOnInfo) {
               $scope.addOnPrice = $scope.addOnPrice + addOnInfo.price.regularPrice;
               });
               $scope.planAndAddOn = (parseInt($scope.addOnPrice)) + (parseInt($scope.planPrice)) ;
               $scope.calculateTax();*/
            }
          },
          function (reason) {
            $scope.planAndAddOnInfoError = true;
          }
        );

        promise = httpService.send(
          'v1/wireless/prepaid/transaction/history', // TODO : Need to change
          {
            accountNumber: $scope.ban,
            ctn: $scope.ctn
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.transactionHistoryInfoError = true;
            } else {
              transactionHistoryService.setResponse(result.data);
              $scope.transactionResponse = result.data;
              $scope.transactionHistory = [];
              var length = $scope.transactionResponse.en.transactionHistory.length;
              var size = length < 5 ? length : 5;
              for (var i = 0; i < size; i++) {
                if (uteLocale.language === 'en') {
                  $scope.transactionHistory.push($scope.transactionResponse.en.transactionHistory[i]);
                } else {
                  $scope.transactionHistory.push($scope.transactionResponse.fr.transactionHistory[i]);
                  $.each($scope.transactionHistory, function (key, value) {
                    var date = new Date(value.date);
                    value.date = date;
                  })
                }
              }
              console.log('$scope.transactionHistory :: ' + $scope.transactionHistory);

            }
          },
          function (reason) {
            $scope.transactionHistoryInfoError = true;
          }
        );

        if (!prepaidRegisteredCCInfoService.getTokenizedCCNumber()) {
          promise = httpService.send(
            'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
            {
              accountNumber: $scope.ban,
              ctn: $scope.ctn
            });

          promise.then(
            function (result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.creditCardRegistrationInfoError = true;
              } else {
                //alert('Got userInfo Successfully');
                $scope.creditCardRegistrationInfo = result.data;
                if ($scope.creditCardRegistrationInfo.registrationStatus) {
                  // $scope.name =
                  prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus($scope.creditCardRegistrationInfo.registrationStatus);
                  prepaidRegisteredCCInfoService.setTokenizedCCNumber($scope.creditCardRegistrationInfo.creditCardInfo.creditCardNo);
                  prepaidRegisteredCCInfoService.setMonth($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                  prepaidRegisteredCCInfoService.setYear($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                }
                prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus($scope.creditCardRegistrationInfo.registrationStatus);
              }
            },
            function (reason) {
              $scope.creditCardRegistrationInfoError = true;
            }
          );
        } else {
          $scope.creditCardRegistrationInfo = {};
          $scope.creditCardRegistrationInfo.registrationStatus = prepaidRegisteredCCInfoService.getCreditCardRegistrationStatus();
          $scope.creditCardRegistrationInfo.creditCardInfo = {};
          $scope.creditCardRegistrationInfo.creditCardInfo.creditCardNo = prepaidRegisteredCCInfoService.getTokenizedCCNumber();
          $scope.creditCardRegistrationInfo.creditCardInfo.expiryDate = prepaidRegisteredCCInfoService.getMonth();
        }

        if (!prepaidUserInfoService.getFirstName()) {
          promise = httpService.send(
            'v1/wireless/prepaid/creditcard/retrieve/userinfo', // TODO : Need to change
            {
              accountNumber: $scope.ban,
              ctn: $scope.ctn
            });

          promise.then(
            function (result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.userInfoError = true;
              } else {
                //alert('Got userInfo Successfully');
                $scope.userInfo = result.data;
                console.log('$scope.userInfo :: ' + $scope.userInfo);
                prepaidUserInfoService.setFirstName($scope.userInfo.firstName);
                prepaidUserInfoService.setLastName($scope.userInfo.lastName);
                prepaidUserInfoService.setEmailAddress($scope.userInfo.emailAddress);
                prepaidUserInfoService.setBillingAddress($scope.userInfo.billingAddress);
              }
            },
            function (reason) {
              $scope.userInfoError = true;
            }
          );
        } else {
          $scope.userInfo = {};
          $scope.userInfo.firstName = prepaidUserInfoService.getFirstName();
          $scope.userInfo.lastName = prepaidUserInfoService.getLastName();
        }


        promise = httpService.send(
          'v1/refill/autorefill/scheduled/details', // TODO : Need to change
          {
            accountNumber: $scope.ban,
            ctn: $scope.ctn,
            language: $scope.language
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.error != '') {
              $scope.autoRefillSubscriptionInfoError = true;
              console.log('AutoRefillSubscriptionInfo Error');
            } else {
              console.log('Got AutoRefillSubscriptionInfo Successfully');
              $scope.autoRefillSubscriptionInfo = result.data;
              console.log('$scope.autoRefillSubscriptionInfo :: ' + $scope.autoRefillSubscriptionInfo);
              prepaidAutoRefillInfoService.setAutoPayPlanInfo($scope.autoRefillSubscriptionInfo.autoPayPlan);
              prepaidAutoRefillInfoService.setAutoRefillBalanceInfo($scope.autoRefillSubscriptionInfo.autoRefillBalance);
              var date = new Date($scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate);
              $scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate = date;
            }
          },
          function (reason) {
            $scope.autoRefillSubscriptionInfoError = true;
          }
        );


      };

      $scope.addOnDetails = function () {
        var promise = httpService.send(
          'v1/wireless/prepaid/dashboard/addOn', // TODO : Need to change
          {
            accountNumber: $scope.ban,
            ctn: $scope.ctn,
            language: $scope.language
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.addonListInfoError = true;
            } else {
              //alert('Got FidoRewardsInfo Successfully');
              $scope.addonListInfo = result.data;
              console.log('$scope.addonInfo :: ' + $scope.addonListInfo);
              angular.forEach($scope.addonListInfo.addonDetailList, function (addOnInfo) {
                $scope.addOnPrice = $scope.addOnPrice + addOnInfo.amount;
              });
              $scope.planAndAddOn = (parseInt($scope.planPrice)) + (parseInt($scope.addOnPrice));
              $scope.calculateTax();
            }
          },
          function (reason) {
            $scope.addonListInfoError = true;
          }
        );

      };

      $scope.calculateTax = function () {
        var promise = httpService.send(
          'v1/refill/autorefill/tax/amount', {
            accountNumber: $scope.ban,
            ctn: $scope.ctn,
            refillAmount: $scope.planAndAddOn,
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.calculateTaxInfoError = true;
            } else {
              $scope.calculateTaxInfo = result.data;

            }
          },
          function (reason) {
            $scope.calculateTaxInfoError = true;
          }
        );


      };
      $scope.go = function (state) {
        $state.go(state);
      };

      $scope.init();
    }]);

})();
